import * as Yup from "yup";

export const changeRoleSchema = Yup.object().shape({
  roleName: Yup.string().required("Select a role"),
  description: Yup.string().nullable(),
});

export const newAdminSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  surname: Yup.string().required("Surname is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: Yup.string().required("Phone number is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  roleName: Yup.string().required("Role is required"),
  accessType: Yup.string()
    .oneOf(["ROLE_INITIATOR", "ROLE_APPROVAL"])
    .required("Select access type"),
});

export const profileSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: Yup.string().required("Phone number is required"),
  address: Yup.string().required("Address is required"),
  district: Yup.string().required("District is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  gender: Yup.string().oneOf(["MALE", "FEMALE"]).required("Select gender"),
  isActive: Yup.boolean(),
});
